var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-upload",class:{'full-width': _vm.isFullWidth}},[_c('image-upload',{ref:"imageUpload",attrs:{"image":_vm.uploadImageUrl,"callback":_vm.setImage,"proxyWidth":"625","proxyHeight":"500"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }